// Cloudinary URL helper for TIRAMISÙ & Co.
// - Native Cloudinary URLs → injects f_auto,q_auto and any width you request
// - Remote URLs (e.g. Unsplash) → routes through Cloudinary's /image/fetch/ so
//   they get optimized (WebP/AVIF), cached on the CDN, and resized.
// - Local /api/files/... URLs are left untouched (they still stream from our
//   backend for pre-Cloudinary uploads).

const CLOUD_NAME = "kphaxnct";
const BASE = `https://res.cloudinary.com/${CLOUD_NAME}`;

function txString({ w, h, crop = "limit" }) {
  const parts = ["f_auto", "q_auto"];
  if (w) parts.push(`w_${w}`);
  if (h) parts.push(`h_${h}`);
  if (w || h) parts.push(`c_${crop}`);
  return parts.join(",");
}

/**
 * Build an optimized image URL.
 * @param {string} src   Absolute URL (Cloudinary / remote) or /api/files/... path
 * @param {{w?:number,h?:number,crop?:"limit"|"fill"|"fit"|"thumb"}} opts
 */
export function cldImage(src, opts = {}) {
  if (!src) return src;

  // Backend-served files (pre-Cloudinary uploads) — leave alone
  if (src.startsWith("/api/")) return src;

  const tx = txString(opts);

  // Already a Cloudinary URL — inject transformations after /upload/
  const cldMatch = src.match(/^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload)\/(.+)$/);
  if (cldMatch) {
    // strip any existing tx segment (single path segment right after /upload/)
    const rest = cldMatch[2].replace(/^(?:[a-z]_[^/]+(?:,[a-z]_[^/]+)*\/)?/, "");
    return `${cldMatch[1]}/${tx}/${rest}`;
  }

  // Remote URL (Unsplash, other CDNs) — route via /image/fetch/
  if (/^https?:\/\//.test(src)) {
    return `${BASE}/image/fetch/${tx}/${encodeURIComponent(src)}`;
  }

  return src;
}
